module.exports = __webpack_public_path__ + "static/media/1O2A0801.5697d659.jpg";